export interface EncounterActions {
  timestamp: string;
  type: string;
  noteContent: string;
}

export interface EncounterTimerObject {
  coordinatorId?: string;
  coordinatorName?: string;
  memberId: string;
  memberName?: string;
  duration: number;
  escalatedDuration?: number;
  actions: EncounterActions[];
  pause: boolean;
}

export interface EncounterTimerContextInterface {
  current: EncounterTimerObject | null;
  list: EncounterTimerObject[];
}

export const encounterTimerContext = {
  current: null,
  list: []
};